import { Column } from "../inventory-list/inventory-list-column-def";

export class SelectedColumn {
    column: Column;
    selected: boolean;
}